import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import Sidebar from './Sidebar';
import TopNav from './TopNav';
import { useActionItemStore } from '@/store/actionItemStore';

const { Header, Sider, Content } = Layout;

const AppShell = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const fetchActionItemCount = useActionItemStore((s) => s.fetchCount);

  useEffect(() => {
    fetchActionItemCount();
    const interval = setInterval(fetchActionItemCount, 60000);
    return () => clearInterval(interval);
  }, [fetchActionItemCount]);

  return (
    <Layout style={{ height: '100vh', overflow: 'hidden', background: 'transparent' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        breakpoint="xl"
        onBreakpoint={(broken) => setCollapsed(broken)}
        width={260}
        collapsedWidth={72}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          background: 'transparent',
          borderRight: 'none',
        }}
        trigger={null}
      >
        <Sidebar collapsed={collapsed} onCollapse={() => setCollapsed(!collapsed)} />
      </Sider>
      <Layout style={{ marginLeft: collapsed ? 72 : 260, transition: 'margin-left 0.2s', height: '100vh', overflow: 'hidden', background: 'transparent' }}>
        <Header
          className="app-topbar"
          style={{
            padding: 0,
            zIndex: 100,
            height: 60,
            lineHeight: '60px',
            flexShrink: 0,
          }}
        >
          <TopNav />
        </Header>
        <Content style={{ background: 'transparent', flex: 1, minHeight: 0, overflow: 'auto' }}>
          <div key={location.pathname} className="ui-page-enter" style={{ padding: '28px 28px', minHeight: 360 }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppShell;
